import { ServiceTransport } from '@tencent/s2-client-vue-lib';
import { AppEnum } from '.';

/**
 * 文章服务
 * @class ServiceArticle
 * @extends {ServiceTransport}
 */
class ServiceArticle extends ServiceTransport {
	/**
	 * Creates an instance of ServiceArticle.
	 *
	 * @memberOf ServiceArticle
	 */
	constructor() {
		super(AppEnum.DEV_BASE_URL);
	}

	/** document hooks */
	public async getArticles(params: any): Promise<any> {
		return await this.get('/articles', params);
	}

	/** document hooks */
	public async getArticle(id: number, params: any): Promise<any> {
		return await this.get(`/articles/${id}`, params);
	}

	/** document hooks */
	public async createArticle(data: any): Promise<any> {
		return await this.post('/articles', data);
	}

	/** document hooks */
	public async updateArticle(id: number, data: any): Promise<any> {
		return await this.put(`/articles/${id}`, data);
	}

	/** document hooks */
	public async deleteArticle(id: number): Promise<any> {
		return await this['delete'](`/articles/${id}`, {});
	}

	/** document hooks */
	public async getPageviews(params: any): Promise<any> {
		return await this.get('/pageviews', params);
	}
}

export default new ServiceArticle();

/** document hooks */
export const defaultArticleData: IArticleData = {
	id: 0,
	status: 'draft',
	title: '',
	fullContent: '',
	abstractContent: '',
	sourceURL: '',
	imageURL: '',
	timestamp: '',
	platforms: ['a-platform'],
	disableComment: false,
	importance: 0,
	author: '',
	reviewer: '',
	type: '',
	pageviews: 0
};

/** iarticle */
export interface IArticleData {
	id: number;
	status: string;
	title: string;
	abstractContent: string;
	fullContent: string;
	sourceURL: string;
	imageURL: string;
	timestamp: string | number;
	platforms: string[];
	disableComment: boolean;
	importance: number;
	author: string;
	reviewer: string;
	type: string;
	pageviews: number;
}

/** irole */
export interface IRoleData {
	key: string;
	name: string;
	description: string;
	routes: any;
}

/** itrans */
export interface ITransactionData {
	orderId: string;
	timestamp: string | number;
	username: string;
	price: number;
	status: string;
}
